/**
 * Customer session: the JWT from POST /api/customers/login or /register, kept in localStorage under 'token'
 * (the key the API helpers and the realtime socket read). The backend sets the token's lifetime (exp claim);
 * the app signs out when it passes or when the API rejects the token.
 */
const KEY = 'token'
export const SESSION_EXPIRED_EVENT = 'tradesmen:session-expired'

export function getToken() {
  try { return localStorage.getItem(KEY) } catch { return null }
}
export function saveToken(token) {
  try { localStorage.setItem(KEY, token) } catch { /* storage blocked: session lasts for this page only */ }
}
export function clearToken() {
  try { localStorage.removeItem(KEY) } catch { /* nothing stored */ }
}

/** Expiry of a JWT in ms (its exp claim), or null when it has none or cannot be read */
export function tokenExpiry(token) {
  try {
    const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const { exp } = JSON.parse(atob(part.padEnd(part.length + ((4 - (part.length % 4)) % 4), '=')))
    return typeof exp === 'number' ? exp * 1000 : null
  } catch {
    return null
  }
}

export const isExpired = (token, now = Date.now()) => {
  const exp = tokenExpiry(token)
  return exp != null && exp <= now
}

/**
 * True when an API answer means the session is over: 401, or 403 from the customer-token check
 * (utils/customerAuth.js answers "Invalid or expired token"). Other 403s are ordinary refusals.
 */
export function isSessionFailure(status, data, token = getToken()) {
  if (!token) return false
  if (status === 401) return true
  return status === 403 && (isExpired(token) || /invalid or expired token/i.test(String(data?.error || '')))
}

/** API helpers call this with every failed response; AuthContext signs out when the session is over */
export function reportAuthFailure(status, data) {
  if (isSessionFailure(status, data)) window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT))
}
